var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.773,
    height: 22.656,
    viewBox: "0 0 30.773 22.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3641",
    "data-name": "Group 3641",
    transform: "translate(0 1.135)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    x2: 27.782,
    transform: "translate(0 10.194)",
    fill: "none",
    stroke: "#014FE0",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5184",
    "data-name": "Path 5184",
    d: "M4746.192,2065.415l11.789,10.194-11.789,10.193",
    transform: "translate(-4729.5 -2065.415)",
    fill: "none",
    stroke: "#014FE0",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowBlue);
export default __webpack_public_path__ + "static/media/right-arrow-blue.853aab7923a46d228b193884207016f0.svg";
export { ForwardRef as ReactComponent };